// مكتبة أيقونات التابات والقوائم (شاشة إعدادات التابات والصلاحيات + السايد بار).
// أول 53 مفتاح هما الأسماء القديمة: ثابتة علشان التابات المحفوظة في الداتا بيز (WebIconKey / IconKey).
// لإضافة أيقونة: import + سطر في SIDEBAR_ICON_LIST بمفتاح جديد (حروف إنجليزي صغيرة).
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ApiIcon from '@mui/icons-material/Api';
import AppsIcon from '@mui/icons-material/Apps';
import ArchiveIcon from '@mui/icons-material/Archive';
import ArticleIcon from '@mui/icons-material/Article';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AttachmentIcon from '@mui/icons-material/Attachment';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BadgeIcon from '@mui/icons-material/Badge';
import BalanceIcon from '@mui/icons-material/Balance';
import BarChartIcon from '@mui/icons-material/BarChart';
import BlockIcon from '@mui/icons-material/Block';
import BoltIcon from '@mui/icons-material/Bolt';
import BookIcon from '@mui/icons-material/Book';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import BrushIcon from '@mui/icons-material/Brush';
import BugReportIcon from '@mui/icons-material/BugReport';
import BuildIcon from '@mui/icons-material/Build';
import BusinessIcon from '@mui/icons-material/Business';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CakeIcon from '@mui/icons-material/Cake';
import CalculateIcon from '@mui/icons-material/Calculate';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CallIcon from '@mui/icons-material/Call';
import CameraIcon from '@mui/icons-material/Camera';
import CampaignIcon from '@mui/icons-material/Campaign';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import CategoryIcon from '@mui/icons-material/Category';
import CelebrationIcon from '@mui/icons-material/Celebration';
import ChairIcon from '@mui/icons-material/Chair';
import ChatIcon from '@mui/icons-material/Chat';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import CloseIcon from '@mui/icons-material/Close';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import CodeIcon from '@mui/icons-material/Code';
import CollectionsIcon from '@mui/icons-material/Collections';
import CommentIcon from '@mui/icons-material/Comment';
import ComputerIcon from '@mui/icons-material/Computer';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import ConstructionIcon from '@mui/icons-material/Construction';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ContactsIcon from '@mui/icons-material/Contacts';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import CottageIcon from '@mui/icons-material/Cottage';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import DataObjectIcon from '@mui/icons-material/DataObject';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DescriptionIcon from '@mui/icons-material/Description';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import DiamondIcon from '@mui/icons-material/Diamond';
import DirectionsIcon from '@mui/icons-material/Directions';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DiscountIcon from '@mui/icons-material/Discount';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import DnsIcon from '@mui/icons-material/Dns';
import DomainIcon from '@mui/icons-material/Domain';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import DownloadIcon from '@mui/icons-material/Download';
import DrawIcon from '@mui/icons-material/Draw';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import EditIcon from '@mui/icons-material/Edit';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ElderlyIcon from '@mui/icons-material/Elderly';
import EmailIcon from '@mui/icons-material/Email';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import ErrorIcon from '@mui/icons-material/Error';
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ExploreIcon from '@mui/icons-material/Explore';
import ExtensionIcon from '@mui/icons-material/Extension';
import FaceIcon from '@mui/icons-material/Face';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FactoryIcon from '@mui/icons-material/Factory';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FeedIcon from '@mui/icons-material/Feed';
import FeedbackIcon from '@mui/icons-material/Feedback';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import FlagIcon from '@mui/icons-material/Flag';
import FlightIcon from '@mui/icons-material/Flight';
import FolderIcon from '@mui/icons-material/Folder';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ForumIcon from '@mui/icons-material/Forum';
import GavelIcon from '@mui/icons-material/Gavel';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GradeIcon from '@mui/icons-material/Grade';
import GridViewIcon from '@mui/icons-material/GridView';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupsIcon from '@mui/icons-material/Groups';
import Groups3Icon from '@mui/icons-material/Groups3';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HandymanIcon from '@mui/icons-material/Handyman';
import HardwareIcon from '@mui/icons-material/Hardware';
import HeadsetIcon from '@mui/icons-material/Headset';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import HealingIcon from '@mui/icons-material/Healing';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HistoryIcon from '@mui/icons-material/History';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import HomeIcon from '@mui/icons-material/Home';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import HotelIcon from '@mui/icons-material/Hotel';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HouseIcon from '@mui/icons-material/House';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import HubIcon from '@mui/icons-material/Hub';
import ImageIcon from '@mui/icons-material/Image';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import InboxIcon from '@mui/icons-material/Inbox';
import InfoIcon from '@mui/icons-material/Info';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InsightsIcon from '@mui/icons-material/Insights';
import InventoryIcon from '@mui/icons-material/Inventory';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import KeyIcon from '@mui/icons-material/Key';
import LanIcon from '@mui/icons-material/Lan';
import LanguageIcon from '@mui/icons-material/Language';
import LaptopIcon from '@mui/icons-material/Laptop';
import LaunchIcon from '@mui/icons-material/Launch';
import LayersIcon from '@mui/icons-material/Layers';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LinkIcon from '@mui/icons-material/Link';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockResetIcon from '@mui/icons-material/LockReset';
import LoopIcon from '@mui/icons-material/Loop';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import MailIcon from '@mui/icons-material/Mail';
import ManIcon from '@mui/icons-material/Man';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import MapIcon from '@mui/icons-material/Map';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MedicationIcon from '@mui/icons-material/Medication';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import MemoryIcon from '@mui/icons-material/Memory';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import MessageIcon from '@mui/icons-material/Message';
import MicIcon from '@mui/icons-material/Mic';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import MoneyIcon from '@mui/icons-material/Money';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import MovieIcon from '@mui/icons-material/Movie';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import NavigationIcon from '@mui/icons-material/Navigation';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import NoteIcon from '@mui/icons-material/Note';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import NotesIcon from '@mui/icons-material/Notes';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PaidIcon from '@mui/icons-material/Paid';
import PaletteIcon from '@mui/icons-material/Palette';
import PasswordIcon from '@mui/icons-material/Password';
import PaymentIcon from '@mui/icons-material/Payment';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PeopleIcon from '@mui/icons-material/People';
import PercentIcon from '@mui/icons-material/Percent';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PieChartIcon from '@mui/icons-material/PieChart';
import PlaceIcon from '@mui/icons-material/Place';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import PolicyIcon from '@mui/icons-material/Policy';
import PollIcon from '@mui/icons-material/Poll';
import PreviewIcon from '@mui/icons-material/Preview';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PrintIcon from '@mui/icons-material/Print';
import PsychologyIcon from '@mui/icons-material/Psychology';
import PublicIcon from '@mui/icons-material/Public';
import QrCodeIcon from '@mui/icons-material/QrCode';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import QuizIcon from '@mui/icons-material/Quiz';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RedeemIcon from '@mui/icons-material/Redeem';
import RedoIcon from '@mui/icons-material/Redo';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveIcon from '@mui/icons-material/Remove';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import ReportIcon from '@mui/icons-material/Report';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import RestoreIcon from '@mui/icons-material/Restore';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import SavingsIcon from '@mui/icons-material/Savings';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SchoolIcon from '@mui/icons-material/School';
import ScienceIcon from '@mui/icons-material/Science';
import SearchIcon from '@mui/icons-material/Search';
import SecurityIcon from '@mui/icons-material/Security';
import SellIcon from '@mui/icons-material/Sell';
import SendIcon from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import ShareIcon from '@mui/icons-material/Share';
import ShieldIcon from '@mui/icons-material/Shield';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import SmsIcon from '@mui/icons-material/Sms';
import SortIcon from '@mui/icons-material/Sort';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import SpeakerIcon from '@mui/icons-material/Speaker';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import StarIcon from '@mui/icons-material/Star';
import StarRateIcon from '@mui/icons-material/StarRate';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import StorageIcon from '@mui/icons-material/Storage';
import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SupportIcon from '@mui/icons-material/Support';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import SyncIcon from '@mui/icons-material/Sync';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import TableChartIcon from '@mui/icons-material/TableChart';
import TabletIcon from '@mui/icons-material/Tablet';
import TaskIcon from '@mui/icons-material/Task';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import TerminalIcon from '@mui/icons-material/Terminal';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import TimelineIcon from '@mui/icons-material/Timeline';
import TimerIcon from '@mui/icons-material/Timer';
import TodayIcon from '@mui/icons-material/Today';
import TopicIcon from '@mui/icons-material/Topic';
import TrainIcon from '@mui/icons-material/Train';
import TranslateIcon from '@mui/icons-material/Translate';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TuneIcon from '@mui/icons-material/Tune';
import TvIcon from '@mui/icons-material/Tv';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import UndoIcon from '@mui/icons-material/Undo';
import UpdateIcon from '@mui/icons-material/Update';
import UploadIcon from '@mui/icons-material/Upload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import VideocamIcon from '@mui/icons-material/Videocam';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import WalletIcon from '@mui/icons-material/Wallet';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WarningIcon from '@mui/icons-material/Warning';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import WcIcon from '@mui/icons-material/Wc';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import WidgetsIcon from '@mui/icons-material/Widgets';
import WifiIcon from '@mui/icons-material/Wifi';
import WomanIcon from '@mui/icons-material/Woman';
import WorkIcon from '@mui/icons-material/Work';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

// [المفتاح المحفوظ، اسم الأيقونة بالإنجليزي، الكومبوننت]
export const SIDEBAR_ICON_LIST = [
  ['home', 'Home', HomeIcon],
  ['payment', 'Payment', PaymentIcon],
  ['message', 'Message', MessageIcon],
  ['accountbalance', 'AccountBalance', AccountBalanceIcon],
  ['report', 'Report', ReportIcon],
  ['support', 'SupportAgent', SupportAgentIcon],
  ['analytics', 'Analytics', AnalyticsIcon],
  ['groups', 'Groups', GroupsIcon],
  ['school', 'School', SchoolIcon],
  ['livehelp', 'LiveHelp', LiveHelpIcon],
  ['list', 'FormatListBulleted', FormatListBulletedIcon],
  ['history', 'History', HistoryIcon],
  ['today', 'Today', TodayIcon],
  ['contactsupport', 'ContactSupport', ContactSupportIcon],
  ['emojievents', 'EmojiEvents', EmojiEventsIcon],
  ['handshake', 'Handshake', HandshakeIcon],
  ['star', 'Star', StarIcon],
  ['campaign', 'Campaign', CampaignIcon],
  ['librarybooks', 'LibraryBooks', LibraryBooksIcon],
  ['dashboard', 'DashboardCustomize', DashboardCustomizeIcon],
  ['assessment', 'Assessment', AssessmentIcon],
  ['campaignoutline', 'CampaignOutlined', CampaignOutlinedIcon],
  ['paid', 'Paid', PaidIcon],
  ['emojioutline', 'EmojiEventsOutlined', EmojiEventsOutlinedIcon],
  ['querystats', 'QueryStats', QueryStatsIcon],
  ['payments', 'PaymentsOutlined', PaymentsOutlinedIcon],
  ['workspacepremium', 'WorkspacePremium', WorkspacePremiumIcon],
  ['percent', 'Percent', PercentIcon],
  ['playlistremove', 'PlaylistRemove', PlaylistRemoveIcon],
  ['currencyexchange', 'CurrencyExchange', CurrencyExchangeIcon],
  ['swaphoriz', 'SwapHoriz', SwapHorizIcon],
  ['businesscenter', 'BusinessCenter', BusinessCenterIcon],
  ['localatm', 'LocalAtm', LocalAtmIcon],
  ['receipt', 'ReceiptLong', ReceiptLongIcon],
  ['description', 'Description', DescriptionIcon],
  ['menubook', 'MenuBook', MenuBookIcon],
  ['personadd', 'PersonAddAlt1', PersonAddAlt1Icon],
  ['services', 'MiscellaneousServices', MiscellaneousServicesIcon],
  ['lockreset', 'LockReset', LockResetIcon],
  ['historymanage', 'ManageHistory', ManageHistoryIcon],
  ['admin', 'AdminPanelSettings', AdminPanelSettingsIcon],
  ['folder', 'FolderShared', FolderSharedIcon],
  ['storefront', 'Storefront', StorefrontIcon],
  ['howtoreg', 'HowToReg', HowToRegIcon],
  ['upload', 'UploadFile', UploadFileIcon],
  ['ratereview', 'RateReview', RateReviewIcon],
  ['systemupdate', 'SystemUpdateAlt', SystemUpdateAltIcon],
  ['block', 'Block', BlockIcon],
  ['poll', 'Poll', PollIcon],
  ['add', 'Add', AddIcon],
  ['logout', 'ExitToApp', ExitToAppIcon],
  ['tune', 'Tune', TuneIcon],
  ['security', 'Security', SecurityIcon],
  ['person', 'Person', PersonIcon],
  ['people', 'People', PeopleIcon],
  ['personoutline', 'PersonOutline', PersonOutlineIcon],
  ['accountcircle', 'AccountCircle', AccountCircleIcon],
  ['badge', 'Badge', BadgeIcon],
  ['contactpage', 'ContactPage', ContactPageIcon],
  ['contacts', 'Contacts', ContactsIcon],
  ['contactphone', 'ContactPhone', ContactPhoneIcon],
  ['contactmail', 'ContactMail', ContactMailIcon],
  ['face', 'Face', FaceIcon],
  ['supervisoraccount', 'SupervisorAccount', SupervisorAccountIcon],
  ['supervisedusercircle', 'SupervisedUserCircle', SupervisedUserCircleIcon],
  ['manageaccounts', 'ManageAccounts', ManageAccountsIcon],
  ['personsearch', 'PersonSearch', PersonSearchIcon],
  ['personremove', 'PersonRemove', PersonRemoveIcon],
  ['personaddalt', 'PersonAddAlt', PersonAddAltIcon],
  ['groupadd', 'GroupAdd', GroupAddIcon],
  ['diversity3', 'Diversity3', Diversity3Icon],
  ['woman', 'Woman', WomanIcon],
  ['man', 'Man', ManIcon],
  ['wc', 'Wc', WcIcon],
  ['familyrestroom', 'FamilyRestroom', FamilyRestroomIcon],
  ['elderly', 'Elderly', ElderlyIcon],
  ['childcare', 'ChildCare', ChildCareIcon],
  ['accessibility', 'Accessibility', AccessibilityIcon],
  ['work', 'Work', WorkIcon],
  ['workoutline', 'WorkOutline', WorkOutlineIcon],
  ['apartment', 'Apartment', ApartmentIcon],
  ['business', 'Business', BusinessIcon],
  ['domain', 'Domain', DomainIcon],
  ['corporatefare', 'CorporateFare', CorporateFareIcon],
  ['store', 'Store', StoreIcon],
  ['locationcity', 'LocationCity', LocationCityIcon],
  ['homework', 'HomeWork', HomeWorkIcon],
  ['meetingroom', 'MeetingRoom', MeetingRoomIcon],
  ['chair', 'Chair', ChairIcon],
  ['factory', 'Factory', FactoryIcon],
  ['warehouse', 'Warehouse', WarehouseIcon],
  ['engineering', 'Engineering', EngineeringIcon],
  ['construction', 'Construction', ConstructionIcon],
  ['handyman', 'Handyman', HandymanIcon],
  ['build', 'Build', BuildIcon],
  ['hardware', 'Hardware', HardwareIcon],
  ['attachmoney', 'AttachMoney', AttachMoneyIcon],
  ['money', 'Money', MoneyIcon],
  ['savings', 'Savings', SavingsIcon],
  ['wallet', 'Wallet', WalletIcon],
  ['accountbalancewallet', 'AccountBalanceWallet', AccountBalanceWalletIcon],
  ['creditcard', 'CreditCard', CreditCardIcon],
  ['creditscore', 'CreditScore', CreditScoreIcon],
  ['pricechange', 'PriceChange', PriceChangeIcon],
  ['pricecheck', 'PriceCheck', PriceCheckIcon],
  ['requestquote', 'RequestQuote', RequestQuoteIcon],
  ['receipt-alt', 'Receipt', ReceiptIcon],
  ['calculate', 'Calculate', CalculateIcon],
  ['sell', 'Sell', SellIcon],
  ['shoppingcart', 'ShoppingCart', ShoppingCartIcon],
  ['shoppingbag', 'ShoppingBag', ShoppingBagIcon],
  ['localoffer', 'LocalOffer', LocalOfferIcon],
  ['discount', 'Discount', DiscountIcon],
  ['loyalty', 'Loyalty', LoyaltyIcon],
  ['cardgiftcard', 'CardGiftcard', CardGiftcardIcon],
  ['redeem', 'Redeem', RedeemIcon],
  ['trendingup', 'TrendingUp', TrendingUpIcon],
  ['trendingdown', 'TrendingDown', TrendingDownIcon],
  ['showchart', 'ShowChart', ShowChartIcon],
  ['stackedlinechart', 'StackedLineChart', StackedLineChartIcon],
  ['piechart', 'PieChart', PieChartIcon],
  ['donutlarge', 'DonutLarge', DonutLargeIcon],
  ['leaderboard', 'Leaderboard', LeaderboardIcon],
  ['insights', 'Insights', InsightsIcon],
  ['timeline', 'Timeline', TimelineIcon],
  ['barchart', 'BarChart', BarChartIcon],
  ['equalizer', 'Equalizer', EqualizerIcon],
  ['tablechart', 'TableChart', TableChartIcon],
  ['summarize', 'Summarize', SummarizeIcon],
  ['assignment', 'Assignment', AssignmentIcon],
  ['assignmentturnedin', 'AssignmentTurnedIn', AssignmentTurnedInIcon],
  ['assignmentlate', 'AssignmentLate', AssignmentLateIcon],
  ['assignmentreturn', 'AssignmentReturn', AssignmentReturnIcon],
  ['factcheck', 'FactCheck', FactCheckIcon],
  ['checklist', 'Checklist', ChecklistIcon],
  ['rulefolder', 'RuleFolder', RuleFolderIcon],
  ['taskalt', 'TaskAlt', TaskAltIcon],
  ['task', 'Task', TaskIcon],
  ['playlistaddcheck', 'PlaylistAddCheck', PlaylistAddCheckIcon],
  ['inventory', 'Inventory', InventoryIcon],
  ['inventory2', 'Inventory2', Inventory2Icon],
  ['contentpaste', 'ContentPaste', ContentPasteIcon],
  ['article', 'Article', ArticleIcon],
  ['feed', 'Feed', FeedIcon],
  ['newspaper', 'Newspaper', NewspaperIcon],
  ['note', 'Note', NoteIcon],
  ['noteadd', 'NoteAdd', NoteAddIcon],
  ['stickynote2', 'StickyNote2', StickyNote2Icon],
  ['editnote', 'EditNote', EditNoteIcon],
  ['notes', 'Notes', NotesIcon],
  ['textsnippet', 'TextSnippet', TextSnippetIcon],
  ['topic', 'Topic', TopicIcon],
  ['folder-alt', 'Folder', FolderIcon],
  ['folderopen', 'FolderOpen', FolderOpenIcon],
  ['foldercopy', 'FolderCopy', FolderCopyIcon],
  ['createnewfolder', 'CreateNewFolder', CreateNewFolderIcon],
  ['drivefolderupload', 'DriveFolderUpload', DriveFolderUploadIcon],
  ['cloudupload', 'CloudUpload', CloudUploadIcon],
  ['clouddownload', 'CloudDownload', CloudDownloadIcon],
  ['clouddone', 'CloudDone', CloudDoneIcon],
  ['attachment', 'Attachment', AttachmentIcon],
  ['attachfile', 'AttachFile', AttachFileIcon],
  ['pictureaspdf', 'PictureAsPdf', PictureAsPdfIcon],
  ['insertdrivefile', 'InsertDriveFile', InsertDriveFileIcon],
  ['filepresent', 'FilePresent', FilePresentIcon],
  ['print', 'Print', PrintIcon],
  ['archive', 'Archive', ArchiveIcon],
  ['unarchive', 'Unarchive', UnarchiveIcon],
  ['event', 'Event', EventIcon],
  ['eventnote', 'EventNote', EventNoteIcon],
  ['eventavailable', 'EventAvailable', EventAvailableIcon],
  ['calendarmonth', 'CalendarMonth', CalendarMonthIcon],
  ['daterange', 'DateRange', DateRangeIcon],
  ['schedule', 'Schedule', ScheduleIcon],
  ['accesstime', 'AccessTime', AccessTimeIcon],
  ['alarmon', 'AlarmOn', AlarmOnIcon],
  ['timer', 'Timer', TimerIcon],
  ['hourglassempty', 'HourglassEmpty', HourglassEmptyIcon],
  ['update', 'Update', UpdateIcon],
  ['pendingactions', 'PendingActions', PendingActionsIcon],
  ['watchlater', 'WatchLater', WatchLaterIcon],
  ['email', 'Email', EmailIcon],
  ['mail', 'Mail', MailIcon],
  ['inbox', 'Inbox', InboxIcon],
  ['send', 'Send', SendIcon],
  ['chat', 'Chat', ChatIcon],
  ['forum', 'Forum', ForumIcon],
  ['questionanswer', 'QuestionAnswer', QuestionAnswerIcon],
  ['sms', 'Sms', SmsIcon],
  ['phone', 'Phone', PhoneIcon],
  ['phoneintalk', 'PhoneInTalk', PhoneInTalkIcon],
  ['call', 'Call', CallIcon],
  ['notifications', 'Notifications', NotificationsIcon],
  ['notificationsactive', 'NotificationsActive', NotificationsActiveIcon],
  ['announcement', 'Announcement', AnnouncementIcon],
  ['feedback', 'Feedback', FeedbackIcon],
  ['comment', 'Comment', CommentIcon],
  ['connectwithoutcontact', 'ConnectWithoutContact', ConnectWithoutContactIcon],
  ['share', 'Share', ShareIcon],
  ['autostories', 'AutoStories', AutoStoriesIcon],
  ['locallibrary', 'LocalLibrary', LocalLibraryIcon],
  ['book', 'Book', BookIcon],
  ['bookmark', 'Bookmark', BookmarkIcon],
  ['bookmarks', 'Bookmarks', BookmarksIcon],
  ['quiz', 'Quiz', QuizIcon],
  ['science', 'Science', ScienceIcon],
  ['psychology', 'Psychology', PsychologyIcon],
  ['lightbulb', 'Lightbulb', LightbulbIcon],
  ['emojiobjects', 'EmojiObjects', EmojiObjectsIcon],
  ['historyedu', 'HistoryEdu', HistoryEduIcon],
  ['castforeducation', 'CastForEducation', CastForEducationIcon],
  ['copresent', 'CoPresent', CoPresentIcon],
  ['draw', 'Draw', DrawIcon],
  ['brush', 'Brush', BrushIcon],
  ['palette', 'Palette', PaletteIcon],
  ['translate', 'Translate', TranslateIcon],
  ['language', 'Language', LanguageIcon],
  ['public', 'Public', PublicIcon],
  ['settings', 'Settings', SettingsIcon],
  ['settingsapplications', 'SettingsApplications', SettingsApplicationsIcon],
  ['extension', 'Extension', ExtensionIcon],
  ['widgets', 'Widgets', WidgetsIcon],
  ['apps', 'Apps', AppsIcon],
  ['gridview', 'GridView', GridViewIcon],
  ['viewmodule', 'ViewModule', ViewModuleIcon],
  ['viewlist', 'ViewList', ViewListIcon],
  ['dashboard-alt', 'Dashboard', DashboardIcon],
  ['spacedashboard', 'SpaceDashboard', SpaceDashboardIcon],
  ['category', 'Category', CategoryIcon],
  ['layers', 'Layers', LayersIcon],
  ['hub', 'Hub', HubIcon],
  ['accounttree', 'AccountTree', AccountTreeIcon],
  ['devicehub', 'DeviceHub', DeviceHubIcon],
  ['lan', 'Lan', LanIcon],
  ['storage', 'Storage', StorageIcon],
  ['dns', 'Dns', DnsIcon],
  ['memory', 'Memory', MemoryIcon],
  ['code', 'Code', CodeIcon],
  ['terminal', 'Terminal', TerminalIcon],
  ['bugreport', 'BugReport', BugReportIcon],
  ['dataobject', 'DataObject', DataObjectIcon],
  ['api', 'Api', ApiIcon],
  ['shield', 'Shield', ShieldIcon],
  ['gppgood', 'GppGood', GppGoodIcon],
  ['verifieduser', 'VerifiedUser', VerifiedUserIcon],
  ['verified', 'Verified', VerifiedIcon],
  ['lock', 'Lock', LockIcon],
  ['lockopen', 'LockOpen', LockOpenIcon],
  ['key', 'Key', KeyIcon],
  ['vpnkey', 'VpnKey', VpnKeyIcon],
  ['fingerprint', 'Fingerprint', FingerprintIcon],
  ['password', 'Password', PasswordIcon],
  ['policy', 'Policy', PolicyIcon],
  ['gavel', 'Gavel', GavelIcon],
  ['balance', 'Balance', BalanceIcon],
  ['flag', 'Flag', FlagIcon],
  ['reportproblem', 'ReportProblem', ReportProblemIcon],
  ['warning', 'Warning', WarningIcon],
  ['error', 'Error', ErrorIcon],
  ['info', 'Info', InfoIcon],
  ['help', 'Help', HelpIcon],
  ['helpoutline', 'HelpOutline', HelpOutlineIcon],
  ['search', 'Search', SearchIcon],
  ['managesearch', 'ManageSearch', ManageSearchIcon],
  ['filteralt', 'FilterAlt', FilterAltIcon],
  ['sort', 'Sort', SortIcon],
  ['visibility', 'Visibility', VisibilityIcon],
  ['preview', 'Preview', PreviewIcon],
  ['zoomin', 'ZoomIn', ZoomInIcon],
  ['explore', 'Explore', ExploreIcon],
  ['travelexplore', 'TravelExplore', TravelExploreIcon],
  ['map', 'Map', MapIcon],
  ['place', 'Place', PlaceIcon],
  ['locationon', 'LocationOn', LocationOnIcon],
  ['mylocation', 'MyLocation', MyLocationIcon],
  ['navigation', 'Navigation', NavigationIcon],
  ['directions', 'Directions', DirectionsIcon],
  ['directionscar', 'DirectionsCar', DirectionsCarIcon],
  ['directionsbus', 'DirectionsBus', DirectionsBusIcon],
  ['localshipping', 'LocalShipping', LocalShippingIcon],
  ['flight', 'Flight', FlightIcon],
  ['train', 'Train', TrainIcon],
  ['checkcircle', 'CheckCircle', CheckCircleIcon],
  ['cancel', 'Cancel', CancelIcon],
  ['highlightoff', 'HighlightOff', HighlightOffIcon],
  ['doneall', 'DoneAll', DoneAllIcon],
  ['done', 'Done', DoneIcon],
  ['close', 'Close', CloseIcon],
  ['remove', 'Remove', RemoveIcon],
  ['addcircle', 'AddCircle', AddCircleIcon],
  ['removecircle', 'RemoveCircle', RemoveCircleIcon],
  ['edit', 'Edit', EditIcon],
  ['delete', 'Delete', DeleteIcon],
  ['deletesweep', 'DeleteSweep', DeleteSweepIcon],
  ['restore', 'Restore', RestoreIcon],
  ['sync', 'Sync', SyncIcon],
  ['autorenew', 'Autorenew', AutorenewIcon],
  ['refresh', 'Refresh', RefreshIcon],
  ['loop', 'Loop', LoopIcon],
  ['undo', 'Undo', UndoIcon],
  ['redo', 'Redo', RedoIcon],
  ['swapvert', 'SwapVert', SwapVertIcon],
  ['importexport', 'ImportExport', ImportExportIcon],
  ['download', 'Download', DownloadIcon],
  ['upload-alt', 'Upload', UploadIcon],
  ['launch', 'Launch', LaunchIcon],
  ['openinnew', 'OpenInNew', OpenInNewIcon],
  ['link', 'Link', LinkIcon],
  ['starrate', 'StarRate', StarRateIcon],
  ['favorite', 'Favorite', FavoriteIcon],
  ['thumbup', 'ThumbUp', ThumbUpIcon],
  ['thumbsupdown', 'ThumbsUpDown', ThumbsUpDownIcon],
  ['militarytech', 'MilitaryTech', MilitaryTechIcon],
  ['celebration', 'Celebration', CelebrationIcon],
  ['cake', 'Cake', CakeIcon],
  ['grade', 'Grade', GradeIcon],
  ['diamond', 'Diamond', DiamondIcon],
  ['bolt', 'Bolt', BoltIcon],
  ['localfiredepartment', 'LocalFireDepartment', LocalFireDepartmentIcon],
  ['whatshot', 'Whatshot', WhatshotIcon],
  ['rocketlaunch', 'RocketLaunch', RocketLaunchIcon],
  ['house', 'House', HouseIcon],
  ['cottage', 'Cottage', CottageIcon],
  ['hotel', 'Hotel', HotelIcon],
  ['restaurant', 'Restaurant', RestaurantIcon],
  ['localcafe', 'LocalCafe', LocalCafeIcon],
  ['localhospital', 'LocalHospital', LocalHospitalIcon],
  ['medicalservices', 'MedicalServices', MedicalServicesIcon],
  ['healthandsafety', 'HealthAndSafety', HealthAndSafetyIcon],
  ['healing', 'Healing', HealingIcon],
  ['vaccines', 'Vaccines', VaccinesIcon],
  ['medication', 'Medication', MedicationIcon],
  ['monitorheart', 'MonitorHeart', MonitorHeartIcon],
  ['fitnesscenter', 'FitnessCenter', FitnessCenterIcon],
  ['sportssoccer', 'SportsSoccer', SportsSoccerIcon],
  ['computer', 'Computer', ComputerIcon],
  ['laptop', 'Laptop', LaptopIcon],
  ['phoneandroid', 'PhoneAndroid', PhoneAndroidIcon],
  ['tablet', 'Tablet', TabletIcon],
  ['tv', 'Tv', TvIcon],
  ['camera', 'Camera', CameraIcon],
  ['photocamera', 'PhotoCamera', PhotoCameraIcon],
  ['videocam', 'Videocam', VideocamIcon],
  ['image', 'Image', ImageIcon],
  ['collections', 'Collections', CollectionsIcon],
  ['movie', 'Movie', MovieIcon],
  ['mic', 'Mic', MicIcon],
  ['headset', 'Headset', HeadsetIcon],
  ['speaker', 'Speaker', SpeakerIcon],
  ['wifi', 'Wifi', WifiIcon],
  ['qrcode', 'QrCode', QrCodeIcon],
  ['qrcode2', 'QrCode2', QrCode2Icon],
  ['qrcodescanner', 'QrCodeScanner', QrCodeScannerIcon],
  ['support-alt', 'Support', SupportIcon],
  ['headsetmic', 'HeadsetMic', HeadsetMicIcon],
  ['volunteeractivism', 'VolunteerActivism', VolunteerActivismIcon],
  ['groups3', 'Groups3', Groups3Icon],
];

export const SIDEBAR_ICON_COMPONENTS = Object.fromEntries(SIDEBAR_ICON_LIST.map(([key, , Icon]) => [key, Icon]));
export const SIDEBAR_ICON_OPTIONS = SIDEBAR_ICON_LIST.map(([key]) => key);
export const SIDEBAR_ICON_LABELS = Object.fromEntries(SIDEBAR_ICON_LIST.map(([key, name]) => [key, name]));
